/** Descriptions for repayments that are not associated with a terminal. */
export const NON_TERMINAL_DESCRIPTION_TERMS = ["refund", "adjustment"] as const;

/** Data sources for repayments that are allocated directly to a cash advance. */
export const NON_TERMINAL_DATA_SOURCES = [
  "other",
  "legal",
  "competitor",
] as const;

/** Data sources for which assigning a terminal is optional. */
export const OPTIONAL_TERMINAL_DATA_SOURCES = ["direct payment"] as const;

export function isTerminalNotApplicable(
  description: string | undefined | null,
  dataSource?: string | undefined | null,
): boolean {
  const normalizedDescription = description?.trim().toLowerCase();
  const normalizedDataSource = dataSource?.trim().toLowerCase();

  return !!(
    !!normalizedDescription &&
    NON_TERMINAL_DESCRIPTION_TERMS.some((term) =>
      normalizedDescription.includes(term),
    ) ||
    (normalizedDataSource &&
      NON_TERMINAL_DATA_SOURCES.includes(
        normalizedDataSource as (typeof NON_TERMINAL_DATA_SOURCES)[number],
      ))
  );
}

export function isTerminalRequired(
  description: string | undefined | null,
  dataSource?: string | undefined | null,
): boolean {
  const normalizedDataSource = dataSource?.trim().toLowerCase();

  return !(
    isTerminalNotApplicable(description, dataSource) ||
    (normalizedDataSource &&
      OPTIONAL_TERMINAL_DATA_SOURCES.includes(
        normalizedDataSource as (typeof OPTIONAL_TERMINAL_DATA_SOURCES)[number],
      ))
  );
}
